/* Funnel graph. Generated by generate-data.py from
   research/quiz-funnel-smooche/funnel-data.json, with the Lumavay overrides
   in that script applied (exit URL, meta title, favicon).
   Safe to hand-edit copy here; re-running the script overwrites this file. */
window.FUNNEL = {
 "startId": "start_1786726376914_r2jzlza17",
 "nodes": {
  "step_1786726377133_1t1sb9gpq": {
   "id": "step_1786726377133_1t1sb9gpq",
   "kind": "exit",
   "name": "To product page",
   "size": {
    "h": 200,
    "w": 280
   },
   "position": {
    "x": 8400,
    "y": 200
   },
   "redirectUrl": "https://lumavay.com/products/lumavay-collagen-peptide-serum?view=lumaway2"
  },
  "step_1786726377133_4lsygdyu8": {
   "id": "step_1786726377133_4lsygdyu8",
   "kind": "step",
   "name": "Checkpoint 1",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "html": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n<title>Section Stepper — 1 of 3</title>\n<style>\n  *{margin:0;padding:0;box-sizing:border-box}\n  body{background:transparent;font-family:Futura,\"Futura PT\",\"Century Gothic\",Avenir,\"Segoe UI\",system-ui,-apple-system,sans-serif}\n  .sf-stepper{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;padding:2px 0 10px}\n  .sf-pill{display:inline-flex;align-items:center;gap:7px;padding:5px 12px 5px 6px;border-radius:999px;background:#EFEFEF;font-size:14px;font-weight:700;line-height:1;white-space:nowrap}\n  .sf-pill.is-done{background:#E3F5E9;color:#3FA46A}\n  .sf-pill.is-todo{background:#EFEFEF;color:#A3A3A3}\n  .sf-dot{width:18px;height:18px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;flex:0 0 18px}\n  .sf-pill.is-done .sf-dot{background:#3FA46A}\n  .sf-pill.is-todo .sf-dot{background:#C9C9C9}\n  .sf-dot svg{display:block}\n  @media (max-width:400px){.sf-pill{font-size:12.5px;padding:4px 10px 4px 5px}}\n</style>\n</head>\n<body>\n  <div class=\"sf-stepper\">\n    <span class=\"sf-pill is-done\">\n      <span class=\"sf-dot\"><svg width=\"10\" height=\"10\" viewBox=\"0 0 12 12\" fill=\"none\"><path d=\"M2.5 6.2l2.3 2.3 4.7-5\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n      Section 1\n    </span>\n    <span class=\"sf-pill is-todo\"><span class=\"sf-dot\"></span>Section 2</span>\n    <span class=\"sf-pill is-todo\"><span class=\"sf-dot\"></span>Section 3</span>\n  </div>\n</body>\n</html>\n",
     "kind": "custom_html"
    },
    {
     "kind": "title",
     "text": "Interesting! Your answers match 2 of our 5 Wrinkle Types"
    },
    {
     "kind": "text",
     "text": "A few more questions will pin it down."
    },
    {
     "html": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n<title>Checkpoint Testimonials</title>\n<style>\n  *{margin:0;padding:0;box-sizing:border-box}\n  body{background:transparent;font-family:Futura,\"Futura PT\",\"Century Gothic\",Avenir,\"Segoe UI\",system-ui,-apple-system,sans-serif;color:#151515}\n  .sf-reviews{display:flex;flex-direction:column;gap:18px;padding:8px 0 4px}\n  .sf-review{background:#FFFFFF;border:1px solid #EDEDED;border-radius:14px;padding:18px 18px 16px}\n  .sf-stars{color:#C8A96A;font-size:15px;letter-spacing:1px;line-height:1;margin-bottom:10px}\n  .sf-quote{font-size:15px;line-height:1.5;color:#2B2B2B;margin-bottom:14px}\n  .sf-name{font-size:15px;font-weight:700;color:#151515;margin-bottom:3px}\n  .sf-verified{font-size:13.5px;color:#B08D4A}\n  .sf-verified b{font-weight:400;margin-right:3px}\n</style>\n</head>\n<body>\n  <div class=\"sf-reviews\">\n    <div class=\"sf-review\">\n      <div class=\"sf-stars\">★★★★★</div>\n      <div class=\"sf-quote\">\"I saw a facebook ad and filled in a quiz. They recommended me a product, and my {{problem}} all disappeared after 9 weeks...\"</div>\n      <div class=\"sf-name\">Linda K. 62</div>\n      <div class=\"sf-verified\"><b>✓</b>Verified customer</div>\n    </div>\n    <div class=\"sf-review\">\n      <div class=\"sf-stars\">★★★★★</div>\n      <div class=\"sf-quote\">\"Best recommendation ever. I've been using it for over a year now. I look younger than ever\"</div>\n      <div class=\"sf-name\">Bea F. 68</div>\n      <div class=\"sf-verified\"><b>✓</b>Verified customer</div>\n    </div>\n  </div>\n</body>\n</html>\n",
     "kind": "custom_html"
    }
   ],
   "position": {
    "x": 1600,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_8fqc823x0": {
   "id": "step_1786726377133_8fqc823x0",
   "kind": "step",
   "name": "Biggest concern",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "What bothers you MOST when you look in the mirror? 🪞"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_gd6mui6vs",
       "text": "Deep wrinkles & folds"
      },
      {
       "id": "opt_1786726377134_6r6d75vmk",
       "text": "Fine lines"
      },
      {
       "id": "opt_1786726377134_vuyj9ubau",
       "text": "Sagging, loose skin"
      },
      {
       "id": "opt_1786726377134_gloe65fqo",
       "text": "Crepey skin texture"
      },
      {
       "id": "opt_1786726377134_dbplrk5lm",
       "text": "Dark spots & uneven tone"
      },
      {
       "id": "opt_1786726377134_w17w1v5yv",
       "text": "Tired, dull look"
      }
     ],
     "variableName": "concern"
    }
   ],
   "position": {
    "x": 400,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_8k0kpxksk": {
   "id": "step_1786726377133_8k0kpxksk",
   "kind": "step",
   "name": "Pledge",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Your plan takes 5 minutes a day"
    },
    {
     "kind": "text",
     "text": "Ready to commit to that and get your confidence back? 💪"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_mnw1yu3f8",
       "text": "Yes, I'm ready! 💪"
      },
      {
       "id": "opt_1786726377134_uzqr41hc1",
       "text": "I think so, show me my plan"
      }
     ],
     "variableName": "pledge"
    }
   ],
   "position": {
    "x": 6800,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_9w7vmu87x": {
   "id": "step_1786726377133_9w7vmu87x",
   "kind": "step",
   "name": "How long",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "How long has this bothered you? ⌛"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_058krhr0q",
       "text": "Less than a year"
      },
      {
       "id": "opt_1786726377134_lz8w8ixc7",
       "text": "1–3 years"
      },
      {
       "id": "opt_1786726377134_6lsm4qybl",
       "text": "3–5 years"
      },
      {
       "id": "opt_1786726377134_70orgovgw",
       "text": "More than 5 years"
      },
      {
       "id": "opt_1786726377134_z2r8zk497",
       "text": "As long as I can remember"
      }
     ],
     "variableName": "time"
    }
   ],
   "position": {
    "x": 2000,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_bdxk3vsjf": {
   "id": "step_1786726377133_bdxk3vsjf",
   "kind": "step",
   "name": "Results",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "html": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n<title>Quiz Complete Pill</title>\n<style>\n  *{margin:0;padding:0;box-sizing:border-box}\n  body{background:transparent;font-family:Futura,\"Futura PT\",\"Century Gothic\",Avenir,\"Segoe UI\",system-ui,-apple-system,sans-serif}\n  .sf-wrap{display:flex;justify-content:center;padding:2px 0 8px}\n  .sf-pill{display:inline-flex;align-items:center;gap:8px;padding:6px 14px 6px 7px;border-radius:999px;background:#E3F5E9;color:#3FA46A;font-size:16px;font-weight:700;line-height:1}\n  .sf-dot{width:19px;height:19px;border-radius:50%;background:#3FA46A;display:inline-flex;align-items:center;justify-content:center;flex:0 0 19px}\n  .sf-dot svg{display:block}\n  @media (max-width:400px){.sf-pill{font-size:14px}}\n</style>\n</head>\n<body>\n  <div class=\"sf-wrap\">\n    <span class=\"sf-pill\">\n      <span class=\"sf-dot\"><svg width=\"11\" height=\"11\" viewBox=\"0 0 12 12\" fill=\"none\"><path d=\"M2.5 6.2l2.3 2.3 4.7-5\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n      Quiz complete. Free bottle unlocked\n    </span>\n  </div>\n</body>\n</html>\n",
     "kind": "custom_html"
    },
    {
     "kind": "title",
     "text": "Your 8 week plan"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\">You've dealt with this for <strong>{{time}}</strong>. This is what can <strong>change</strong> in the next <strong>8 weeks</strong> if you <strong>act now.</strong></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "alt": "Before and after 8 weeks",
     "url": "assets/results-hero.webp",
     "kind": "image"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: left;\">For a woman who is {{age}} years old, has Wrinkle Type Static-{{stage}} and wants to get rid of {{problem}}, this plan is perfect for you.</p><p style=\"text-align: left;\">8 weeks from now, you'll look in the mirror either way. The only question is whether you look the same, or have significantly reduced {{problem}}. It's up you.</p><p style=\"text-align: left;\"><em>Your information will <u>not be stored</u></em></p>",
     "isRichText": true,
     "contentFormat": "html"
    }
   ],
   "position": {
    "x": 7600,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "See my plan (special surprise)"
  },
  "step_1786726377133_dd1s5s5lf": {
   "id": "step_1786726377133_dd1s5s5lf",
   "kind": "step",
   "name": "Mechanism — topicals",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Why does nothing work on deep wrinkles & sagging skin?"
    },
    {
     "alt": "How creams stop at the skin surface",
     "url": "assets/mechanism-topicals-hero.webp",
     "kind": "image"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: left;\">Because most anti-aging creams, serums, and retinol <strong>only work on the surface</strong>.</p><p style=\"text-align: left;\">They can hydrate the top layer and make your skin look smoother for a while. But they do not address <strong>the deeper support structure that thins with age</strong>, creating the deeper lines, crepey texture, and loss of firmness you see in the mirror.</p><p style=\"text-align: left;\">If you want to achieve truly younger-looking skin, you need the right ingredients to work deeper, like the <strong>copper peptides and PDRN</strong> which support collagen-related activity in the deeper layers of your skin.</p>",
     "isRichText": true,
     "contentFormat": "html"
    }
   ],
   "position": {
    "x": 4000,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_es8qec3ku": {
   "id": "step_1786726377133_es8qec3ku",
   "kind": "step",
   "name": "Goal feeling",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "8 weeks from now, what would smoother skin change for you? 💫"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_dr5aoi2xq",
       "text": "My confidence",
       "emoji": "👑"
      },
      {
       "id": "opt_1786726377134_w4og57ng6",
       "text": "How I feel in photos",
       "emoji": "📸"
      },
      {
       "id": "opt_1786726377134_j57t9b99b",
       "text": "How I feel without makeup",
       "emoji": "✨"
      },
      {
       "id": "opt_1786726377134_mzzwo3y0p",
       "text": "Everything. I'm ready for a change",
       "emoji": "💫"
      }
     ],
     "variableName": "goal"
    }
   ],
   "position": {
    "x": 5600,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_gwn69dbbw": {
   "id": "step_1786726377133_gwn69dbbw",
   "kind": "step",
   "name": "How did it go",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "And how did that go? 🤔"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_lgtyau75q",
       "text": "Saw real results",
       "emoji": "🌟"
      },
      {
       "id": "opt_1786726377134_xqxqpw78f",
       "text": "Small improvements",
       "emoji": "👍"
      },
      {
       "id": "opt_1786726377134_zmafv8gl0",
       "text": "Barely noticed anything",
       "emoji": "😕"
      },
      {
       "id": "opt_1786726377134_lyr96lq0s",
       "text": "Total waste of money",
       "emoji": "❌"
      },
      {
       "id": "opt_1786726377134_f3zndgilt",
       "text": "Irritated my skin",
       "emoji": "🚨"
      }
     ],
     "variableName": "went"
    }
   ],
   "position": {
    "x": 3200,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_h5fj53iwp": {
   "id": "step_1786726377133_h5fj53iwp",
   "kind": "step",
   "name": "What tried",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "What have you already tried? 🧴"
    },
    {
     "kind": "text",
     "text": "Select all that apply"
    },
    {
     "kind": "question",
     "kindOf": "multi",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_nvs41io1z",
       "text": "Retinol or tretinoin",
       "emoji": "🧪"
      },
      {
       "id": "opt_1786726377134_y6zlwdt33",
       "text": "Anti-aging creams",
       "emoji": "🧴"
      },
      {
       "id": "opt_1786726377134_huqycohj0",
       "text": "Collagen supplements",
       "emoji": "💊"
      },
      {
       "id": "opt_1786726377134_ku6ulepye",
       "text": "At-home devices",
       "emoji": "📱"
      },
      {
       "id": "opt_1786726377134_tt12aoyyp",
       "text": "Nothing yet",
       "emoji": "💁‍♀️"
      }
     ],
     "variableName": "tried"
    }
   ],
   "position": {
    "x": 2400,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_hznyu9fid": {
   "id": "step_1786726377133_hznyu9fid",
   "kind": "step",
   "name": "Transfer",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Adding your free bottle…"
    },
    {
     "kind": "text",
     "text": "Do not close this page"
    },
    {
     "kind": "loading",
     "text": "Adding your free bottle…",
     "style": "bar",
     "seconds": 4
    }
   ],
   "position": {
    "x": 8000,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_jsnj5q66d": {
   "id": "step_1786726377133_jsnj5q66d",
   "kind": "step",
   "name": "Problem areas",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Where do you want to see the biggest change? ✨"
    },
    {
     "kind": "text",
     "text": "Select all that apply. Most women pick 3 or more"
    },
    {
     "kind": "question",
     "kindOf": "multi",
     "layout": "grid",
     "options": [
      {
       "id": "opt_1786726377134_j5fmen3g5",
       "text": "Nasolabial Folds",
       "imageUrl": "assets/problem-areas-opt0-nasolabial-folds.webp"
      },
      {
       "id": "opt_1786726377134_nn4921cy4",
       "text": "Marionette Lines",
       "imageUrl": "assets/problem-areas-opt1-marionette-lines.webp"
      },
      {
       "id": "opt_1786726377134_lj0wf599a",
       "text": "Mouth Wrinkles",
       "imageUrl": "assets/problem-areas-opt2-mouth-wrinkles.webp"
      },
      {
       "id": "opt_1786726377134_bnud6b2p2",
       "text": "Turkey Neck",
       "imageUrl": "assets/problem-areas-opt3-turkey-neck.webp"
      },
      {
       "id": "opt_1786726377134_wt7tugoi4",
       "text": "Sagging Jowls",
       "imageUrl": "assets/problem-areas-opt4-sagging-jowls.webp"
      },
      {
       "id": "opt_1786726377134_iw7l4qp6a",
       "text": "Eye Wrinkles",
       "imageUrl": "assets/problem-areas-opt5-eye-wrinkles.webp"
      }
     ],
     "variableName": "problem"
    }
   ],
   "position": {
    "x": 800,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_n547h29l8": {
   "id": "step_1786726377133_n547h29l8",
   "kind": "step",
   "name": "Event branch",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Is there a moment coming up when you want to look your best? 📅"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_g3qm39yqp",
       "text": "Nothing specific. This is for myself",
       "emoji": "👩"
      },
      {
       "id": "opt_1786726377134_yn17usqw7",
       "text": "A wedding",
       "emoji": "💍"
      },
      {
       "id": "opt_1786726377134_8eqenvwmk",
       "text": "A birthday",
       "emoji": "🎁"
      },
      {
       "id": "opt_1786726377134_ji6vv9kpe",
       "text": "A trip",
       "emoji": "🏖️"
      },
      {
       "id": "opt_1786726377134_x4ixf45i8",
       "text": "A reunion",
       "emoji": "👫"
      },
      {
       "id": "opt_1786726377134_ig5kzo9gp",
       "text": "Another occasion",
       "emoji": "⭐"
      }
     ],
     "variableName": "event"
    }
   ],
   "position": {
    "x": 6000,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue",
   "isConditional": true,
   "conditionalQuestionIndex": 1
  },
  "step_1786726377133_nhjchx3y7": {
   "id": "step_1786726377133_nhjchx3y7",
   "kind": "step",
   "name": "Mirror moment",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "When you see yourself in recent photos, you… 🤳"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_duc7ir6sk",
       "text": "Barely recognize myself",
       "emoji": "😔"
      },
      {
       "id": "opt_1786726377134_bgsp553fb",
       "text": "Look older than I feel",
       "emoji": "😕"
      },
      {
       "id": "opt_1786726377134_kdevs18cp",
       "text": "Avoid photos when I can",
       "emoji": "🫣"
      },
      {
       "id": "opt_1786726377134_hp6yr1f4f",
       "text": "Feel mostly fine. I want to stay ahead",
       "emoji": "🙂"
      }
     ],
     "variableName": "mirror"
    }
   ],
   "position": {
    "x": 5200,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_og8o3t0wd": {
   "id": "step_1786726377133_og8o3t0wd",
   "kind": "step",
   "name": "Mechanism — nothing tried",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Starting from zero is actually the best place to start"
    },
    {
     "alt": "Collagen decline after 30",
     "url": "assets/mechanism-nothing-tried-hero.webp",
     "kind": "image"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: left;\">After 30, skin produces roughly <strong>1% less collagen every year</strong>, which is why wrinkles slowly deepen even when you change nothing. And the usual first steps waste that time: collagen powders get broken down and sent everywhere but your face, and ordinary creams stop at the surface. You get to <strong>skip all of that trial and error</strong>, and start with a serum built to reach the depth where wrinkles actually form.</p>",
     "isRichText": true,
     "contentFormat": "html"
    }
   ],
   "position": {
    "x": 4000,
    "y": -80
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_oilyhzi7a": {
   "id": "step_1786726377133_oilyhzi7a",
   "kind": "step",
   "name": "Monthly spend",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Roughly what do you spend on skincare each month? 💳"
    },
    {
     "kind": "text",
     "text": "No judgment. This just lets us show you what you'd save."
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_hdwj7wxph",
       "text": "Under $25"
      },
      {
       "id": "opt_1786726377134_04fvvsu2l",
       "text": "$25-$50"
      },
      {
       "id": "opt_1786726377134_49h60qikk",
       "text": "$50-$100"
      },
      {
       "id": "opt_1786726377134_j2f0h3htk",
       "text": "Over $100"
      },
      {
       "id": "opt_1786726377134_jdrdcjsfe",
       "text": "I've honestly lost track"
      }
     ],
     "variableName": "spend"
    }
   ],
   "position": {
    "x": 4400,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_ruk5vr835": {
   "id": "step_1786726377133_ruk5vr835",
   "kind": "step",
   "name": "Analysis loader",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Loading results..."
    },
    {
     "kind": "loading",
     "steps": [
      {
       "id": "a1b2c3d4-0001-4a10-9f01-lumavaywrink1",
       "seconds": 5,
       "loadingText": "Mapping Static-{{stage}} pattern...",
       "completedText": "Mapping Static-{{stage}} pattern..."
      },
      {
       "id": "a1b2c3d4-0002-4a10-9f02-lumavaywrink2",
       "seconds": 2.5,
       "loadingText": "Comparing with women aged {{age}}",
       "completedText": "Comparing with women aged {{age}}"
      },
      {
       "id": "a1b2c3d4-0003-4a10-9f03-lumavaywrink3",
       "seconds": 3.5,
       "loadingText": "Already tried {{tried}} …",
       "completedText": "Already tried {{tried}} …"
      },
      {
       "id": "a1b2c3d4-0004-4a10-9f04-lumavaywrink4",
       "seconds": 3,
       "loadingText": "Finalizing your 8-week plan…",
       "completedText": "Finalizing your 8-week plan…"
      }
     ],
     "style": "steps",
     "seconds": 14.0
    },
    {
     "html": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n<title>Analysis Testimonials</title>\n<style>\n  *{margin:0;padding:0;box-sizing:border-box}\n  body{background:transparent;font-family:Futura,\"Futura PT\",\"Century Gothic\",Avenir,\"Segoe UI\",system-ui,-apple-system,sans-serif;color:#151515}\n  .sf-reviews{display:flex;flex-direction:column;gap:18px;padding:8px 0 4px}\n  .sf-review{background:#FFFFFF;border:1px solid #EDEDED;border-radius:14px;padding:18px 18px 16px}\n  .sf-stars{color:#C8A96A;font-size:15px;letter-spacing:1px;line-height:1;margin-bottom:10px}\n  .sf-quote{font-size:15px;line-height:1.5;color:#2B2B2B;margin-bottom:14px}\n  .sf-name{font-size:15px;font-weight:700;color:#151515;margin-bottom:3px}\n  .sf-verified{font-size:13.5px;color:#B08D4A}\n  .sf-verified b{font-weight:400;margin-right:3px}\n</style>\n</head>\n<body>\n  <div class=\"sf-reviews\">\n    <div class=\"sf-review\">\n      <div class=\"sf-stars\">★★★★★</div>\n      <div class=\"sf-quote\">\"I've wasted so much money on creams that did nothing, I genuinely rolled my eyes when my daughter sent me this. Three weeks in and the {{problem}} are the best it has looked in ten years. I keep touching my face. I'm a believer now... I will never use anything else.\"</div>\n      <div class=\"sf-name\">Fiona K. 62</div>\n      <div class=\"sf-verified\"><b>✓</b>Verified customer</div>\n    </div>\n    <div class=\"sf-review\">\n      <div class=\"sf-stars\">★★★★★</div>\n      <div class=\"sf-quote\">\"The wrinkles under my eyes made me look exhausted no matter how much I slept. About a month in, my husband asked if I'd done something different because I looked \"so rested.\" I hadn't told him I was even trying anything. That said it all.\"</div>\n      <div class=\"sf-name\">Anne S. 71</div>\n      <div class=\"sf-verified\"><b>✓</b>Verified customer</div>\n    </div>\n  </div>\n</body>\n</html>\n",
     "kind": "custom_html"
    }
   ],
   "position": {
    "x": 7200,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_slnn0si6d": {
   "id": "step_1786726377133_slnn0si6d",
   "kind": "step",
   "name": "Type reveal",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "html": "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n<title>Section Stepper — 2 of 3</title>\n<style>\n  *{margin:0;padding:0;box-sizing:border-box}\n  body{background:transparent;font-family:Futura,\"Futura PT\",\"Century Gothic\",Avenir,\"Segoe UI\",system-ui,-apple-system,sans-serif}\n  .sf-stepper{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;padding:2px 0 10px}\n  .sf-pill{display:inline-flex;align-items:center;gap:7px;padding:5px 12px 5px 6px;border-radius:999px;background:#EFEFEF;font-size:14px;font-weight:700;line-height:1;white-space:nowrap}\n  .sf-pill.is-done{background:#E3F5E9;color:#3FA46A}\n  .sf-pill.is-todo{background:#EFEFEF;color:#A3A3A3}\n  .sf-dot{width:18px;height:18px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;flex:0 0 18px}\n  .sf-pill.is-done .sf-dot{background:#3FA46A}\n  .sf-pill.is-todo .sf-dot{background:#C9C9C9}\n  .sf-dot svg{display:block}\n  @media (max-width:400px){.sf-pill{font-size:12.5px;padding:4px 10px 4px 5px}}\n</style>\n</head>\n<body>\n  <div class=\"sf-stepper\">\n    <span class=\"sf-pill is-done\">\n      <span class=\"sf-dot\"><svg width=\"10\" height=\"10\" viewBox=\"0 0 12 12\" fill=\"none\"><path d=\"M2.5 6.2l2.3 2.3 4.7-5\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n      Section 1\n    </span>\n    <span class=\"sf-pill is-done\">\n      <span class=\"sf-dot\"><svg width=\"10\" height=\"10\" viewBox=\"0 0 12 12\" fill=\"none\"><path d=\"M2.5 6.2l2.3 2.3 4.7-5\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n      Section 2\n    </span>\n    <span class=\"sf-pill is-todo\"><span class=\"sf-dot\"></span>Section 3</span>\n  </div>\n</body>\n</html>\n",
     "kind": "custom_html"
    },
    {
     "kind": "title",
     "text": "Your wrinkle type is:"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\"><span style=\"color: rgb(176, 141, 74); font-size: 32px;\"><strong>Static-{{stage}}</strong></span></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: left;\">✓ Your pattern centers around static lines and folds, the type where {{tried}} <strong>don't work.</strong></p><p style=\"text-align: left;\">✓ <strong>{{stage}}</strong> means depth, not hopelessness. Static skin shows some of the <strong>most visible treatment responses</strong>.</p><p style=\"text-align: left;\">✓ You've tried {{tried}}. With this pattern, that <strong>result is typical</strong>, and it isn't your fault.</p>",
     "isRichText": true,
     "contentFormat": "html"
    }
   ],
   "position": {
    "x": 4800,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_tnsk1rcbw": {
   "id": "step_1786726377133_tnsk1rcbw",
   "kind": "step",
   "name": "Mechanism — supplements",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Swallowed collagen has a long way to travel. Most of it never arrives."
    },
    {
     "alt": "Why swallowed collagen never reaches the face",
     "url": "assets/mechanism-supplements-hero.webp",
     "kind": "image"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: left;\">When you drink or swallow collagen, your body breaks it into amino acids and sends them wherever it decides they're needed most, and <strong>your face is last in line</strong>. That's why months of powders can pass without a visible change in your mirror. The serum treatment works differently: it <strong>delivers active ingredients directly where your wrinkles actually form</strong>.</p>",
     "isRichText": true,
     "contentFormat": "html"
    }
   ],
   "position": {
    "x": 4000,
    "y": 480
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_twlm6b3ml": {
   "id": "step_1786726377133_twlm6b3ml",
   "kind": "step",
   "name": "Severity stage",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "Which photo looks closest to your skin today? 🔎"
    },
    {
     "kind": "text",
     "text": "Be honest. There's no wrong answer, and your plan depends on it."
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "grid",
     "options": [
      {
       "id": "opt_1786726377134_g7s5cp6c3",
       "text": "Stage 1",
       "subtext": "Mild",
       "imageUrl": "assets/severity-stage-opt0-stage-1.webp"
      },
      {
       "id": "opt_1786726377134_xyjemg3fu",
       "text": "Stage 2",
       "subtext": "Moderate",
       "imageUrl": "assets/severity-stage-opt1-stage-2.webp"
      },
      {
       "id": "opt_1786726377134_61dj2qy8b",
       "text": "Stage 3",
       "subtext": "Deep",
       "imageUrl": "assets/severity-stage-opt2-stage-3.webp"
      },
      {
       "id": "opt_1786726377134_myqcya6lt",
       "text": "Stage 4",
       "subtext": "Very Deep",
       "imageUrl": "assets/severity-stage-opt3-stage-4.webp"
      }
     ],
     "variableName": "stage"
    }
   ],
   "position": {
    "x": 1200,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_utthx4fut": {
   "id": "step_1786726377133_utthx4fut",
   "kind": "ifElse",
   "name": "Supplements or topicals?",
   "size": {
    "h": 180,
    "w": 240
   },
   "position": {
    "x": 3600,
    "y": 200
   },
   "conditions": [
    {
     "id": "condition_1786726377134_dtbzvs8xx",
     "type": "if",
     "label": "If",
     "criteria": [
      {
       "stepId": "step_1786726377133_h5fj53iwp",
       "optionIds": [
        "opt_1786726377134_huqycohj0"
       ],
       "questionIndex": 2
      }
     ],
     "handleId": "condition-if"
    },
    {
     "id": "condition_1786726377134_k0ck9czfk",
     "type": "else",
     "label": "Else",
     "criteria": [],
     "handleId": "condition-else"
    }
   ]
  },
  "step_1786726377133_xvt9zwzuc": {
   "id": "step_1786726377133_xvt9zwzuc",
   "kind": "ifElse",
   "name": "Tried anything?",
   "size": {
    "h": 180,
    "w": 240
   },
   "position": {
    "x": 2800,
    "y": 200
   },
   "conditions": [
    {
     "id": "condition_1786726377134_rylnckxmr",
     "type": "if",
     "label": "If",
     "criteria": [
      {
       "stepId": "step_1786726377133_h5fj53iwp",
       "optionIds": [
        "opt_1786726377134_tt12aoyyp"
       ],
       "questionIndex": 2
      }
     ],
     "handleId": "condition-if"
    },
    {
     "id": "condition_1786726377134_h2f578dmb",
     "type": "else",
     "label": "Else",
     "criteria": [],
     "handleId": "condition-else"
    }
   ]
  },
  "step_1786726377133_ybm86jzup": {
   "id": "step_1786726377133_ybm86jzup",
   "kind": "step",
   "name": "Event date",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "title",
     "text": "When is it? We'll build your timeline around it. 📅"
    },
    {
     "kind": "input",
     "label": "Please select a date",
     "required": false,
     "inputType": "date",
     "variableName": "event_date"
    }
   ],
   "position": {
    "x": 6400,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "step_1786726377133_yg36leja8": {
   "id": "step_1786726377133_yg36leja8",
   "kind": "step",
   "name": "Age",
   "size": {
    "h": 200,
    "w": 280
   },
   "subEls": [
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\"><span style=\"font-size: 16px; color: rgb(176, 141, 74);\"><strong>SUMMER EVENT</strong></span></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\"><span style=\"font-size: 32px;\"><strong>Let's find your Wrinkle Type and build your plan.</strong></span></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\"><span style=\"color: rgb(115, 115, 115); font-size: 16px;\">90 seconds · Free · No email required</span></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "kind": "text",
     "text": "<p style=\"text-align: center;\"><span style=\"font-size: 24px;\"><strong>How old are you? 🤔</strong></span></p>",
     "isRichText": true,
     "contentFormat": "html"
    },
    {
     "kind": "question",
     "kindOf": "single",
     "layout": "list",
     "options": [
      {
       "id": "opt_1786726377134_2i3fdp38c",
       "text": "85+"
      },
      {
       "id": "opt_1786726377134_64i0weixh",
       "text": "75-84"
      },
      {
       "id": "opt_1786726377134_103ieuxxa",
       "text": "65-74"
      },
      {
       "id": "opt_1786726377134_73kl788zv",
       "text": "55-64"
      },
      {
       "id": "opt_1786726377134_lp7bue50t",
       "text": "45-54"
      },
      {
       "id": "opt_1786726377134_ytovtwmcu",
       "text": "Under 45"
      }
     ],
     "variableName": "age"
    }
   ],
   "position": {
    "x": 0,
    "y": 200
   },
   "rotation": 0,
   "buttonText": "Continue"
  },
  "start_1786726376914_r2jzlza17": {
   "id": "start_1786726376914_r2jzlza17",
   "kind": "start",
   "name": "Start",
   "size": {
    "h": 200,
    "w": 280
   },
   "position": {
    "x": -200,
    "y": 0
   }
  }
 },
 "edges": [
  {
   "id": "edge_1786726377133_2jh8tx1t6",
   "to": "step_1786726377133_jsnj5q66d",
   "from": "step_1786726377133_8fqc823x0"
  },
  {
   "id": "edge_1786726377133_35fsg7g5h",
   "to": "step_1786726377133_4lsygdyu8",
   "from": "step_1786726377133_twlm6b3ml"
  },
  {
   "id": "edge_1786726377133_6ne9vek5f",
   "to": "step_1786726377133_twlm6b3ml",
   "from": "step_1786726377133_jsnj5q66d"
  },
  {
   "id": "edge_1786726377133_k6sbk8j43",
   "to": "step_1786726377133_8fqc823x0",
   "from": "step_1786726377133_yg36leja8"
  },
  {
   "id": "edge_1786726377134_10hgvd9s9",
   "to": "step_1786726377133_ybm86jzup",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 3
  },
  {
   "id": "edge_1786726377134_326kk1ig0",
   "to": "step_1786726377133_h5fj53iwp",
   "from": "step_1786726377133_9w7vmu87x"
  },
  {
   "id": "edge_1786726377134_3j1y9o269",
   "to": "step_1786726377133_8k0kpxksk",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 0
  },
  {
   "id": "edge_1786726377134_3zgi4od2z",
   "to": "step_1786726377133_n547h29l8",
   "from": "step_1786726377133_es8qec3ku"
  },
  {
   "id": "edge_1786726377134_61ouu9asf",
   "to": "step_1786726377133_ybm86jzup",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 1
  },
  {
   "id": "edge_1786726377134_66i236t2q",
   "to": "step_1786726377133_xvt9zwzuc",
   "from": "step_1786726377133_h5fj53iwp"
  },
  {
   "id": "edge_1786726377134_809xl3xme",
   "to": "step_1786726377133_og8o3t0wd",
   "from": "step_1786726377133_xvt9zwzuc",
   "sourceConditionId": "condition-if"
  },
  {
   "id": "edge_1786726377134_8738pr6cm",
   "to": "step_1786726377133_utthx4fut",
   "from": "step_1786726377133_gwn69dbbw"
  },
  {
   "id": "edge_1786726377134_8ebmu1y3q",
   "to": "step_1786726377133_8k0kpxksk",
   "from": "step_1786726377133_ybm86jzup"
  },
  {
   "id": "edge_1786726377134_ceix2ikm2",
   "to": "step_1786726377133_bdxk3vsjf",
   "from": "step_1786726377133_ruk5vr835"
  },
  {
   "id": "edge_1786726377134_d3qe9xtly",
   "to": "step_1786726377133_ybm86jzup",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 5
  },
  {
   "id": "edge_1786726377134_hg2jx8fby",
   "to": "step_1786726377133_9w7vmu87x",
   "from": "step_1786726377133_4lsygdyu8"
  },
  {
   "id": "edge_1786726377134_iylruwhqb",
   "to": "step_1786726377133_tnsk1rcbw",
   "from": "step_1786726377133_utthx4fut",
   "sourceConditionId": "condition-if"
  },
  {
   "id": "edge_1786726377134_k659lve02",
   "to": "step_1786726377133_nhjchx3y7",
   "from": "step_1786726377133_slnn0si6d"
  },
  {
   "id": "edge_1786726377134_kd8xrn73u",
   "to": "step_1786726377133_slnn0si6d",
   "from": "step_1786726377133_oilyhzi7a"
  },
  {
   "id": "edge_1786726377134_mbvize0q5",
   "to": "step_1786726377133_ybm86jzup",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 2
  },
  {
   "id": "edge_1786726377134_mqxn5ty17",
   "to": "step_1786726377133_oilyhzi7a",
   "from": "step_1786726377133_og8o3t0wd"
  },
  {
   "id": "edge_1786726377134_pphz3i0ap",
   "to": "step_1786726377133_hznyu9fid",
   "from": "step_1786726377133_bdxk3vsjf"
  },
  {
   "id": "edge_1786726377134_q1no6bbpy",
   "to": "step_1786726377133_ruk5vr835",
   "from": "step_1786726377133_8k0kpxksk"
  },
  {
   "id": "edge_1786726377134_qae4wc0pz",
   "to": "step_1786726377133_es8qec3ku",
   "from": "step_1786726377133_nhjchx3y7"
  },
  {
   "id": "edge_1786726377134_sj1mhm6oa",
   "to": "step_1786726377133_1t1sb9gpq",
   "from": "step_1786726377133_hznyu9fid"
  },
  {
   "id": "edge_1786726377134_somzrlq20",
   "to": "step_1786726377133_oilyhzi7a",
   "from": "step_1786726377133_dd1s5s5lf"
  },
  {
   "id": "edge_1786726377134_uyngoh9mu",
   "to": "step_1786726377133_gwn69dbbw",
   "from": "step_1786726377133_xvt9zwzuc",
   "sourceConditionId": "condition-else"
  },
  {
   "id": "edge_1786726377134_wp1z005jl",
   "to": "step_1786726377133_dd1s5s5lf",
   "from": "step_1786726377133_utthx4fut",
   "sourceConditionId": "condition-else"
  },
  {
   "id": "edge_1786726377134_zbzf7ihvh",
   "to": "step_1786726377133_oilyhzi7a",
   "from": "step_1786726377133_tnsk1rcbw"
  },
  {
   "id": "edge_1786726377134_zj5219hiq",
   "to": "step_1786726377133_ybm86jzup",
   "from": "step_1786726377133_n547h29l8",
   "sourceOptionIndex": 4
  },
  {
   "id": "edge_1786726377136_dgb8k5wbj",
   "to": "step_1786726377133_yg36leja8",
   "from": "start_1786726376914_r2jzlza17"
  }
 ],
 "stepPositions": {
  "step_1786726377133_yg36leja8": 1,
  "step_1786726377133_8fqc823x0": 2,
  "step_1786726377133_jsnj5q66d": 3,
  "step_1786726377133_twlm6b3ml": 4,
  "step_1786726377133_4lsygdyu8": 5,
  "step_1786726377133_9w7vmu87x": 6,
  "step_1786726377133_h5fj53iwp": 7,
  "step_1786726377133_og8o3t0wd": 8,
  "step_1786726377133_gwn69dbbw": 8,
  "step_1786726377133_oilyhzi7a": 9,
  "step_1786726377133_slnn0si6d": 10,
  "step_1786726377133_tnsk1rcbw": 9,
  "step_1786726377133_dd1s5s5lf": 9,
  "step_1786726377133_nhjchx3y7": 11,
  "step_1786726377133_es8qec3ku": 12,
  "step_1786726377133_n547h29l8": 13,
  "step_1786726377133_ybm86jzup": 14,
  "step_1786726377133_8k0kpxksk": 14,
  "step_1786726377133_ruk5vr835": 15,
  "step_1786726377133_bdxk3vsjf": 16,
  "step_1786726377133_hznyu9fid": 17
 },
 "totalSteps": 17,
 "settings": {
  "metadata": {
   "favicon": {
    "url": "assets/favicon-lumavay.png",
    "enabled": true
   },
   "ogImage": {
    "url": "",
    "enabled": false
   },
   "metaTitle": "Lumavay - Serum Quiz",
   "metaDescription": "Find your Wrinkle Type in 90 seconds and unlock your personalised 8-week plan. Free, no email required."
  },
  "brandLogo": {
   "url": "",
   "enabled": false
  },
  "demographic": "genx",
  "themePreset": "editorial",
  "backNavigation": true,
  "progressBar": true,
  "stepProgressCount": false,
  "forwardUrlParams": true
 }
};
